import styled from 'styled-components';
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";

export default styled.div`
  max-width: 59.5rem;
  margin: .375rem auto;
  background-color: ${themeResponsiveProperty('transparent', '#ececec')};
  padding: ${themeResponsiveProperty('.5rem 1rem', null)};
`;
